import React, { createContext, useContext } from "react"

import type { ThemeBottomSectionImageItem, ThemeBottomSectionState } from "@/models/ITrackingPageOptions"

import type { ThemeLayoutShowcaseContentDraft } from "./themeLayoutShowcaseDraft"

export interface ShowcaseThemeLayoutContextValue {
  draft: ThemeLayoutShowcaseContentDraft
  setDraft: React.Dispatch<React.SetStateAction<ThemeLayoutShowcaseContentDraft>>
  /** Bottom Section 弹窗编辑期间的预览 overlay，弹窗关闭后置 null */
  bottomSectionPopupDraft: ThemeBottomSectionState | null
  setBottomSectionPopupDraft: React.Dispatch<React.SetStateAction<ThemeBottomSectionState | null>>
  /** Top Section 图片弹窗编辑期间的预览 overlay（仅图片数组），弹窗关闭后置 null */
  topSectionImagesPopupDraft: ThemeBottomSectionImageItem[] | null
  setTopSectionImagesPopupDraft: React.Dispatch<React.SetStateAction<ThemeBottomSectionImageItem[] | null>>
}

const ShowcaseThemeLayoutContext = createContext<ShowcaseThemeLayoutContextValue | null>(null)

export const ShowcaseThemeLayoutProvider = ShowcaseThemeLayoutContext.Provider

export const useShowcaseThemeLayout = (): ShowcaseThemeLayoutContextValue => {
  const v = useContext(ShowcaseThemeLayoutContext)

  if (!v) {
    throw new Error("useShowcaseThemeLayout must be used within ShowcaseThemeLayoutProvider")
  }

  return v
}
